import { Directive, ElementRef, EnvironmentInjector, HostListener, Input, inject } from '@angular/core';

type ScrollTarget = string | HTMLElement | ElementRef<HTMLElement>;

@Directive({
  selector: '[scrollTo]',
  standalone: true,
})
export default class ScrollToDirective {
  private readonly envInjector = inject(EnvironmentInjector);
  @Input('scrollTo') target!: ScrollTarget;
  @Input() scrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
  };

  @HostListener('click')
  @HostListener('keydown.enter')
  handle(): void {
    const el = this.resolveTarget();
    if (!el) {
      console.warn('ScrollToDirective: target not found:', this.target);
      return;
    }

    setTimeout(() => {
      el.scrollIntoView(this.scrollOptions);
    }, 180);
  }

  private resolveTarget(): HTMLElement | null {
    if (!this.target) return null;
    if (this.target instanceof ElementRef) return this.target.nativeElement;
    if (this.target instanceof HTMLElement) return this.target;

    return document.getElementById(this.target);
  }
}
